// src/components/ActivityChart.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTodaysActivityData } from '../../redux/slices/ActivitySlice';
import CanvasJSReact from '@canvasjs/react-charts';
import { Card, CardBody, CardHeader, Button } from 'react-bootstrap';
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ActivityChart = () => {
  const dispatch = useDispatch();

  // Access user data from Redux store
  const user = useSelector((state) => state.auth.user);
  const {todaysData, loading, error} = useSelector((state) => state.activity);
  // const status = useSelector((state) => state.activity.status);
  
  useEffect(() => {
    if (user && user.user_id) {
      dispatch(fetchTodaysActivityData(user.user_id)); 
    }
  }, [dispatch, user]);

  // Handler to manually refresh data
  const handleRefresh = () => {
    if (user && user.user_id) {
      dispatch(fetchTodaysActivityData(user.user_id)); // Manually fetch data on button click
    }
  };
  
  const dataPoints = todaysData.map(item => ({
    x: new Date(item.time.replace(' ', 'T')), // Replace space with 'T' to create an ISO format
    y: item.activity_level, // Use 'activity_level' as y-axis value
  }));
  

  const options = {
    animationEnabled: true,
    animationDuration: 1000,
    data: [
      {
        type: 'column',
        dataPointWidth: 20,
        dataPoints: dataPoints,
      },
    ],
    axisY: {
      title: 'Activity Level',
      interval: 1,
      minimum: 0,
      maximum: 1,
    },
    axisX: {
      title: 'Time',
      valueFormatString: "DD MMM HH:mm:ss", 
      labelAngle: 180,
    },
    backgroundColor: 'transparent',
  };

  return (
    <Card className='chart-card-large'>
      <CardHeader>
        <div style={{ padding: '10px 15px', borderBottom: '1px solid #dee2e6', backgroundColor: '#f8f9fa', textAlign: 'center' }}>
          <h4 style={{ margin: 0, color: 'rgba(255, 86, 34, 0.85)', fontSize: '27px' }}>Activity Monitoring</h4>
        </div>
      </CardHeader>
      <CardBody>
      {loading && <p>Loading...</p>}
        {error && (
  <p>
    Error: {typeof error === 'string' ? error : error.detail || JSON.stringify(error)}
  </p>
)}
        {!loading && !error && (
          <>
            <CanvasJSChart options={options} />
              {/* Refresh Button */}
              <Button variant="primary" onClick={handleRefresh} style={{ marginTop: '10px' }}>
                  Refresh Data
              </Button>
        </>        
      )}
      </CardBody>
    </Card>
  );
};

export default ActivityChart;


